var IoCContainer = (function() {
  function IoCContainer() { };

  IoCContainer.register = function(type, getInstance) {
    var name = getName(type);
    IoCContainer[name] = getInstance;
    return IoCContainer;
  };

  IoCContainer.resolve = function (type) {
    var name = getName(type);
    if (IoCContainer.hasOwnProperty(name)) {
      return IoCContainer[name]();
    }
    throw new DependencyException('Not found ' + name);
  };

  function getName(type) {
    return /function ([^(]*)/.exec(type.toString())[1];
  }

  return IoCContainer;
}());
